import { IconLinePlus } from "@kalodata/kds-design-icons";
import { Trans } from "react-i18next";
import { twMerge } from "tailwind-merge";

export interface ClipUploadPlaceholderProps {
  className?: string;
  disabled?: boolean;
  placeholderText?: React.ReactNode;
  hint?: React.ReactNode;
  uploadPlaceholder?: React.ReactNode;
}

export const ClipUploadPlaceholder = ({
  className,
  disabled,
  placeholderText,
  hint,
  uploadPlaceholder,
}: ClipUploadPlaceholderProps) => {
  if (uploadPlaceholder) return uploadPlaceholder;

  return (
    <div
      className={twMerge(
        "flex h-full w-full flex-col items-center justify-center rounded-[8px] border bg-kds-bg-overlay p-[12px] transition-colors",
        className,
        disabled
          ? "cursor-not-allowed border-kds-border-subtle opacity-60"
          : "cursor-pointer border-kds-border-subtle hover:border-kds-accent",
      )}
    >
      <div className="flex flex-col items-center gap-[8px]">
        <div className="flex size-[32px] items-center justify-center rounded-full bg-kds-bg-overlay text-kds-fg">
          <IconLinePlus size={16} />
        </div>
        <span className="whitespace-nowrap text-[14px] leading-[1.4] text-kds-fg">
          {placeholderText ?? <Trans>Drag or paste</Trans>}
        </span>
        {hint ? <span className="text-center text-[12px] leading-[1.4] text-kds-fg-soft">{hint}</span> : null}
      </div>
    </div>
  );
};
